<template>
  <div id="app">
    <web-header/>
    <div class="page-content">
      <router-view/>
    </div>
    <web-footer/>
  </div>
</template>

<script>
import Header from './components/header';
import Footer from './components/footer';
export default {
  components: {
    'web-header': Header,
    'web-footer': Footer,
  },
}
</script>

<style>
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.page-content{
  position: relative;
  width: 1240px;
  max-width: 100%;
  margin: 0 auto;
  padding: 20px 10px;
  min-height: calc(100% - 145px);
}
</style>



// WEBPACK FOOTER //
// src/App.vue